<template>
  <div>
    <layout-header></layout-header>
    <layout-sidebar></layout-sidebar>
    <div class="page-wrapper">
      <div class="content">
        <div class="row" v-if="devotion">
          <div class="col-lg-8 col-md-8 col-12">
            <!-- <div class="card" style="height: 100%;"> -->
            <div class="card">
              <div class="card-body">
                <div class="row row-cols-lg-2 row-cols-md-2 " v-if="comments?.length > 0">
                  <div class="col-lg-6 col-md-6">
                    <CommentCard :devotionId="devotion.id"
                                 v-for="(comment) in comments.slice(0, commentHalfLength)" :key="comment.id"
                                 :comment="comment" @deleted="removeComment"/>
                  </div>

                  <div class="col-lg-6 col-md-6">
                    <CommentCard :devotionId="devotion.id"
                                 v-for="(comment) in comments.slice(commentHalfLength, comments.length)"
                                 :key="comment.id" :comment="comment" @deleted="removeComment"/>
                  </div>
                </div>
                <div v-else>
                  <h4>No Comment Yet</h4>
                </div>
              </div>
            </div>

          </div>
          <div class="col-lg-4 col-md-4 col-12">
            <div class="card">
              <div class="card-body">
                <div class="d-md-flex  justify-content-between align-items-center py-3">
                  <div class="" style="color: #1b2850;">
                    <span>Created By: &nbsp;</span>
                    <b class="text-center">
                      {{ devotion?.admin?.name }}
                    </b>
                    <div>
                                            <span>
                                                On: &nbsp;
                                            </span>
                      <b class="text-center">
                        {{ devotion?.created_at }}
                      </b>
                    </div>
                  </div>
                  <div v-if="devotion?.last_edited_by" style="border-right: 1px solid gray;"
                       :style="{ height: '15px' }">
                  </div>
                  <!-- <div v-if="devotion?.last_edited_by" class="d-flex gap-2 align-items-center"
                      style="color: #1b2850;"> -->
                  <div v-if="devotion?.last_edited_by" class=""
                       style="color: #1b2850;">
                    <span>Last Edited By: &nbsp;</span>
                    <b class="text-center">
                      {{ devotion?.last_edited_by?.name }}
                    </b>

                    <div>
                                            <span>
                                                On: &nbsp;
                                            </span>
                      <b class="text-center">
                        {{ devotion?.updated_at }}
                      </b>
                    </div>
                  </div>
                </div>
                <div class="d-flex justify-content-center align-items-center">
                  <img height="150" class="rounded-2" :src="devotion.thumbnail"/>
                </div>
                <h5 class="text-center mb-3 mt-3">{{ devotion.title }}</h5>

                <div class="mb-1" v-if="devotion?.reference">
                  <h6>
                    Reference: {{ devotion.reference?.title }} ({{
                      devotion.reference?.bible_quotation
                    }})
                  </h6>
                </div>

                <div class="mb-3" v-if="devotion?.reference">
                  <p class="fw-bold fst-italic">
                    {{ devotion.reference?.content }}
                  </p>
                </div>

                <div class="mt-3" v-if="devotion?.new_reference">
                  <h6>
                    Reference
                  </h6>
                </div>

                <div class="mb-3" v-if="devotion?.new_reference">
                  <ol>
                    <li v-for="(text, index) in devotion?.new_reference" :key="index">
                      {{ index + 1 }}. {{ text?.book }} {{ text?.chapter }}:{{ text?.verse }}<span
                        v-if="text?.to">-{{ text?.to }}</span>
                    </li>
                  </ol>
                </div>


                <div class="mb-2">
                  <h6>
                    Devotion Content
                  </h6>
                </div>
                <div style="overflow: hidden; word-break: break-all; " v-html="devotion.content">
                </div>

                <div class="mt-3" v-if="devotion?.additional_text">
                  <h6>
                    Additional Text
                  </h6>
                </div>

                <ol v-if="devotion?.additional_text">
                  <li v-for="(text, index) in devotion?.additional_text" :key="index">
                    {{ index + 1 }}. {{ text?.title }} ({{ text?.bible_quotation }})
                  </li>
                </ol>

                <div class="mt-3 mb-2" v-if="devotion?.prayers">
                  <h6>
                    Prayers
                  </h6>
                </div>
                <ol v-if="devotion?.prayers">
                  <li v-for="(prayer, index) in devotion?.prayers" :key="index">
                    {{ index + 1 }}. {{ prayer }}
                  </li>
                </ol>

                <div class="mt-3 mb-2" v-if="devotion?.extras">
                  <div v-for="(extra, index) in devotion?.extras" :key="index">

                    <div class="mb-2">

                      <h6>
                        {{ extra.title }}
                      </h6>

                      <ol class="list-decimal list-inside mt-1">
                        <li v-for="(point, pointIndex) in extra.points" :key="pointIndex">
                          {{ pointIndex + 1 }}. {{ point }}
                        </li>
                      </ol>

                    </div>

                  </div>

                </div>

                <div class="mt-3 mb-3" v-if="devotion?.admin_thumbnails">
                  <h6>
                    Photo Quotes
                  </h6>
                </div>

                <div class="row" v-if="devotion?.admin_thumbnails">
                  <div class="col-lg-4 col-md-6 col-4 mb-3"
                       v-for="(photo, index) in devotion?.admin_thumbnails" :key="index"
                       style="height: 150px;">
                    <img height="10" class="rounded-2" :src="photo.url"
                         style="height: 100%; width: 100%;"/>
                  </div>
                </div>
              </div>
            </div>
          </div>

        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import {computed, onMounted, ref} from "vue";
import {useDevotionStore} from "@/store/devotionStore";
import CommentCard from "./components/comment-card.vue";
import {useRoute} from "vue-router";
import {useCommentStore} from "@/store/commentStore";
import {decodeUrlData} from "./utils/data";

// hooks
const route = useRoute();
// store
const devotionStore = useDevotionStore();
const commentStore = useCommentStore();

// data
const urlData = computed(() => decodeUrlData(route.params['encodedData']));

const devotion = ref({});
// const comments = computed(() => devotion.value ? devotion.value?.analysis?.comments : []);
const comments = ref([]);
const commentHalfLength = computed(() => {
  if (!comments.value) {
    return 0
  } else {
    return comments.value.length > 1 ? Math.round(comments.value.length / 2) : 1;
  }
});

async function removeComment(commentId) {
  await loadDevotionComments();
}

async function loadDevotionComments() {
  comments.value = await commentStore.fetchComments(devotion.value.id);
}

async function loadData() {
    devotion.value = devotionStore.findById(urlData.value.devotionId)?.devotion;
    if (!devotion.value) {
        const data = await devotionStore.fetchDevotionById(urlData.value.devotionId);
        devotion.value = { ...data };
    }
}

// async function loadData() {
//   const local = devotionStore.findById(urlData.value.devotionId);
//
//   if (local) {
//     devotion.value = local.devotion;
//     return;
//   }
//
//   // fallback to API
//   const data = await devotionStore.fetchDevotionByDate(
//       urlData.value.date,
//       urlData.value.type
//   );
//
//   devotion.value = data || {}; // <-- Safe object
// }

onMounted(async () => {
  await loadData();
  await loadDevotionComments();
});
</script>
<style>
.round-avatar {
  width: 50px;
  height: 50px;
  max-width: 100%;
  margin-right: 0;
  border-radius: 20%;
}
</style>
